/* @flow */

import * as React from 'react'

import { WebshopContext } from '../../shared'
import WebshopHeaderClassic from './WebshopHeaderClassic'
import WebshopMobileHeaderClassic from './WebshopMobileHeaderClassic'
import WebshopHeaderModern from './WebshopHeaderModern'

const WebshopHeader = ({ gridItem, ...props }) => {
  const { isMobile } = React.useContext(WebshopContext)

  if (gridItem.data.type === 'modern') {
    return <WebshopHeaderModern gridItem={gridItem} {...props} />
  }

  return isMobile ? (
    <WebshopMobileHeaderClassic {...props} />
  ) : (
    <WebshopHeaderClassic {...props} />
  )
}

export default WebshopHeader
